export function formatCall(call: string): string {
  return call.replace(/[\s\t\r\n]+/g, "").toUpperCase();
}

export function checkCallInAddress(addressText: string, call: string): boolean {
  const lowerAddress = addressText.toLowerCase();
  const lowerCall = call.toLowerCase();
  return lowerAddress.includes(lowerCall);
}

export function chunkArray<T>(array: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}

export function generateUUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
